import { render, staticRenderFns } from "./UserPhotoModal.vue?vue&type=template&id=5f6b018c&scoped=true"
import script from "./UserPhotoModal.vue?vue&type=script&lang=js"
export * from "./UserPhotoModal.vue?vue&type=script&lang=js"
import style0 from "./UserPhotoModal.vue?vue&type=style&index=0&id=5f6b018c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6b018c",
  null
  
)

export default component.exports